module.exports = __webpack_public_path__ + "img/photo.561580ff.jpg";